import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

/* eslint-disable jsx-a11y/href-no-hash */
class MenuItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle(e) {
        e.preventDefault();

        this.setState(state => ({
            open: !state.open,
        }));
    }

    render() {
        const { name, to } = this.props;
        const { open } = this.state;
        const hasChildren = React.Children.count(this.props.children) > 0;

        // Nice dropdown if this has children
        if (hasChildren) {
            return (
                <li className={`${open ? 'open opening' : null}`}>
                    <a href="#" onClick={this.toggle}>
                        <span className="title">{name}</span>
                        <FontAwesomeIcon icon={faAngleDown} fixedWidth={true} />
                    </a>
                    <ul>
                        {this.props.children}
                    </ul>
                </li>
            );
        }

        // Just a link if not
        return (<li><Link to={to}><span className="title">{name}</span></Link></li>);
    }
}

MenuItem.propTypes = {
    name: PropTypes.node.isRequired,
    to: PropTypes.string,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/base/secure/header/menu-item.js